/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LogMessages as ECLogMessages } from '@eatclubapp/ec-component-library';
import { removeMessageAction } from '../../data/actions/logMessageAction';

const LogMessagesWrapper = ({ messages, removeMessage }) => {
  const [open, setOpen] = useState(false);
  const [activeMessage, setActiveMessage] = useState(undefined);

  useEffect(() => {
    if (messages.length && !activeMessage) {
      // Set a new message when there's none active
      setActiveMessage({ ...messages[0] });
      removeMessage(messages[0].id);
      setOpen(true);
    } else if (messages.length && activeMessage && open) {
      // Close an active message when a new one is added
      setOpen(false);
    }
  }, [messages, activeMessage, open, removeMessage]);

  return <ECLogMessages messages={messages} removeMessage={removeMessage} />;
};

const mapStateToProps = (state) => ({
  messages: state.logMessage.messages,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      removeMessage: removeMessageAction,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(LogMessagesWrapper);
